// Studio orgs that have a published widget bundle on the CDN. A copy of
// KNOWN_BRANDS in apps/feed-widget/scripts/build-brands.mjs: Studio cannot
// import widget build scripts, and widgetBrands.test.js keeps the two equal.
export const WIDGET_BRANDS = Object.freeze([
  'ballys',
  'betparx',
  'desertdiamond',
  'gunlake',
  'mohegansun',
  'mohegansungaming',
  'rushstreet',
  'potawatomi',
  'rushbet',
])

// Where the Feed preview host page is published. Staging images point this at
// cdn-staging so a staging Studio previews staging bundles.
export const PREVIEW_HOST_BASE_URL = (
  import.meta.env.VITE_PREVIEW_HOST_BASE_URL || 'https://cdn.wager.games/wager-studio/v1/preview-host/latest'
).replace(/\/+$/, '')

export function previewHostPageUrl(base = PREVIEW_HOST_BASE_URL) {
  return `${base}/preview-host/index.html`
}
